import { TableRow, Box } from '@material-ui/core'
import styled from 'styled-components'
import { customTheme } from '../../../../styles/customTheme'

export const itemNotaFiscalStyles = {
  TableRowHistorico: styled(TableRow)`
    background-color: ${customTheme.colors.blue01};
  `,
  BoxHistorico: styled(Box)`
    padding: 8px;
  `
}
